import { DisplayIconFactory } from './display-icon-factory.interface';
import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class AlertFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const conditionalCls = [];
        conditionalCls.push({
            cls: 'alert',
            condition: () => true
        });

        // @ts-ignore
        // tslint:disable-next-line:triple-equals
        item.isVisible = item.isVisible && item.value != false && item.value != 0; // legacy code - is it still needed?

        // Special condition for 'faults' to make it nicer on the dashboard card
        if (item.name.toUpperCase() === 'FAULT') {
            item.name = item.displayValue;
            item.displayValue = 'Yes';
        }

        return {
            conditionalCls,
            getLabelText: () => item.name,
            materialIcon: 'warning',
            isLabelVisible: () => !!item.actualValue,
            getValue: () => item.displayValue
        };
    }
}
